import {commonActions} from '../../actions/commonActions';
import {transactionSetList} from '../../actions/transactionActions';
import {connect} from 'react-redux';
import List from '../../components/transaction/TransactionList';
import {API_FETCH} from '../../services/FetchService';
import {commonConstants} from "../../constants";
import {getItem as userInfo} from '../../containers/user/AddEditFormPage';


const mapDispatchToProps = dispatch => ({
    onPageLoad: view => {
        dispatch(commonActions.pagePreLoaded(view))
    },
    getList: (value) => {
        dispatch(list(value));
    },
    getUserInfo: (id) => {
        return(dispatch(userInfo(id)))
    },
    /* ------------ -------------- ------------*/
    /* ------------ ON SUbmit Search Form ------------*/
    /* ------------ -------------- ------------*/
    onSubmit: (value)=>{
        dispatch(list(value));
    },

});

export const list = (value) => {
    return (dispatch, getState) => {
        let states = getState()
        let userId;

        if(states.user.getItem && states.user.getItem._id) {
            userId = states.user.getItem._id
            value.benefetiary = userId
        }
        if(value) {
            if(value.created_from && value.created_from._d)
                value.created_from = value.created_from._d.toISOString()
            if(value.created_to && value.created_to._d)
                value.created_to = value.created_to._d.toISOString()
        }

        dispatch({type: commonConstants.FORM_REQUEST});
        API_FETCH.get('transaction',{params: value}).then(list => {
            if(list.status === 201) {
                dispatch({type: commonConstants.FORM_SUCCESS});
            }else {
                dispatch({type: commonConstants.FORM_FAILURE});
            }            dispatch(transactionSetList(list.data));
        }).catch(error => {
            console.log(error);
        });
    }

}


const mapStateToProps = state => {
    return {
        userValue    : state.app.currentUser,
        list         : state.transaction.list,
        common       : state.common,
        initialValues: state.transaction.targetItem,
        userInfo     : state.user.getItem,
    }
};


export default connect(mapStateToProps, mapDispatchToProps)(List);
